import { render, staticRenderFns } from "./ResumeReviewWriter.vue?vue&type=template&id=28bb07a8&"
import script from "./ResumeReviewWriter.vue?vue&type=script&lang=js&"
export * from "./ResumeReviewWriter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports